export default process.env
  .VUE_APP_ALLOW_CHANGING_PAYMENT_METHOD_BUTTON === 'true'
